module.exports = __webpack_public_path__ + "static/img/banner.74a9ac5.png";


//////////////////
// WEBPACK FOOTER
// ./src/common/images/lawColumn/banner.png
// module id = 1O14
// module chunks = 0